var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApprove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_approved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_approved",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 1)",
    fill: "#0A186E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar/Outlined"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2 C6,1.63181016 5.70152308,1.33333333 5.33333333,1.33333333 C4.96514359,1.33333333 4.66666667,1.63181016 4.66666667,2 L4.66666667,2.33333333 L4,2.33333333 C2.71133588,2.33333333 1.66666667,3.37800179 1.66666667,4.66666641 L1.66666667,12.3333333 C1.66666667,13.6219981 2.71133601,14.6666667 4.00000025,14.6666667 L12,14.6666667 C13.2886637,14.6666667 14.3333333,13.6219981 14.3333333,12.3333333 L14.3333333,4.66666667 C14.3333333,3.37800217 13.2886637,2.33333333 12,2.33333333 L11.3333333,2.33333333 L11.3333333,2 C11.3333333,1.63181016 11.0348562,1.33333333 10.6666667,1.33333333 C10.2984772,1.33333333 10,1.63181016 10,2 L10,2.33333333 L6,2.33333333 L6,2 Z M13,5.39332682 L13,4.66666667 C13,4.11438192 12.5522847,3.66666667 12,3.66666667 L11.3333333,3.66666667 L11.3333333,4 C11.3333333,4.36818975 11.0348562,4.66666667 10.6666667,4.66666667 C10.2984772,4.66666667 10,4.36818975 10,4 L10,3.66666667 L6,3.66666667 L6,4 C6,4.36818975 5.70152308,4.66666667 5.33333333,4.66666667 C4.96514359,4.66666667 4.66666667,4.36818975 4.66666667,4 L4.66666667,3.66666667 L4,3.66666667 C3.44771512,3.66666667 3,4.11438192 3,4.66666641 L3,5.39332682 L13,5.39332682 Z M3,6.72666016 L13,6.72666016 L13,12.3333333 C13,12.8856181 12.5522847,13.3333333 12,13.3333333 L4.00000025,13.3333333 C3.44771538,13.3333333 3,12.8856181 3,12.3333333 L3,6.72666016 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3889439,8.95595889 C11.6110928,8.73727013 11.6110928,8.38270551 11.3889439,8.16401665 C11.1667958,7.94532781 10.8066221,7.94532778 10.584474,8.16401659 L7.59958076,10.2135355 L6.30441528,8.93853986 C6.08226683,8.71985095 5.72209316,8.71985095 5.49994472,8.93853967 C5.27779627,9.15722858 5.27779617,9.51179316 5.49994464,9.73048207 L7.18727831,11.3915388 C7.31662673,11.5188728 7.49276953,11.5720654 7.66121365,11.551116 C7.78999787,11.5401815 7.91572026,11.4862036 8.0142761,11.3891828 L11.3889439,8.95595889 Z",
    id: "Vector",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApprove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Approve.dc841bca200a9c73a6d33488dd266f5d.svg";